<script>
export default {
  props: {
    disabled: {
      type: Boolean,
      default: false,
    },
    error: {
      type: Boolean,
      default: false,
    },
    value: {
      type: Number,
      default: undefined,
    },
    min: {
      type: Number,
      default: undefined,
    },
    max: {
      type: Number,
      default: undefined,
    },
    zero: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      $value: `${this.value}`,
      $autofilled: false,
    };
  },
  mounted() {
    this.$el.addEventListener('animationstart', ({ animationName }) => {
      if (animationName === this.$style.onAutoFillStart) {
        this.$data.$autofilled = true;
        if (!this.$el.value) this.$emit('input', '--autofilled--');
      }
      if (animationName === this.$style.onAutoFillCancel) {
        this.$data.$autofilled = false;
      }
    }, false);

    // IE autofill fix
    setTimeout(() => {
      const inputVal = this.$el.value;
      const defineVal = this.$data.$value;
      if (!defineVal && !!inputVal) {
        this.$data.$value = inputVal;
      }
    }, 120);
  },
  watch: {
    value() {
      this.$data.$value = parseInt(this.value, 10);
    },
    '$data.$value': function input(value) {
      this.$emit('input', value);
    },
  },
  methods: {
    update() {
      let currentVal = parseInt(this.$el.value, 10);
      if (this.$props.min && currentVal < this.$props.min) {
        currentVal = this.$el.min;
      }
      if (this.$props.max && currentVal > this.$props.max) {
        currentVal = this.$el.max;
      }
      this.$data.$value = parseInt(currentVal, 10);
    },
    set() {
      const currentVal = parseInt(this.$el.value, 10);
      if (this.$props.zero) {
        if (Number.isNaN(currentVal)) {
          this.$data.$value = 0;
        } else {
          this.$data.$value = parseInt(currentVal, 10);
        }
      } else {
        this.$data.$value = currentVal ? parseInt(currentVal, 10) : parseInt(this.$el.min, 10);
      }
    },
  },
};
</script>

<template lang="pug">
input(
  type="number",
  @input="update()",
  @change="update()",
  @blur="set()",
  :class="[$style.input, error && $style.error]",
  v-model="$data.$value",
  :disabled="disabled",
  :min="min",
  :max="max"
)
</template>

<style module lang="sass">
.input
  display: block
  padding: 0
  border: 0
  box-sizing: border-box
  outline: none
  height: $s_inp_height
  font-size: $s_inp_font
  font-weight: $s_inp_font_weight
  background-color: transparent
  color: $s_inp_font_color
  border-top: 0px solid transparent
  border-bottom: 1px solid $s_inp_border
  transition: border-color $a_speed, border-width $a_speed, color $a_speed
  caret-color: $s_color_main
  &:not(:disabled):hover
    border-top-width: 1px
    border-bottom: 2px solid $s_inp_border_hover

  &:not(:disabled):focus
    border-top-width: 1px
    border-bottom: 2px solid $s_color_main

  &:-webkit-autofill
    background-color: transparent
    -webkit-box-shadow: 0 0 0 $s_inp_height transparent inset
    -webkit-text-fill-color: #795548 !important

  &:disabled
    border-top-width: 0px
    border-bottom-style: dashed
    cursor: not-allowed
    color: $s_inp_text_disabled
    &:-webkit-autofill
      -webkit-text-fill-color: $s_inp_text_disabled !important

  .error.input
    border-top-width: 1px
    border-bottom: 2px solid $s_inp_error_color

input:-webkit-autofill
  background-color: transparent

input:-webkit-autofill
  animation-name: onAutoFillStart

input:not(:-webkit-autofill)
  animation-name: onAutoFillCancel

</style>
